import { render, staticRenderFns } from "./consultationSettings.vue?vue&type=template&id=08a684f2"
import script from "./consultationSettings.vue?vue&type=script&lang=js"
export * from "./consultationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports